import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    IconButton,
    AppBar,
    Toolbar,
    useScrollTrigger,
    Slide,
    Fade,
    Zoom,
    Chip,
    Divider,
    Link as MuiLink,
    Stack,
} from '@mui/material';
import {
    Search as SearchIcon,
    Spa as SpaIcon,
    CalendarToday as CalendarIcon,
    Star as StarIcon,
    People as PeopleIcon,
    TrendingUp as TrendingUpIcon,
    ThumbUp as ThumbUpIcon,
    ChevronLeft,
    ChevronRight,
    Facebook,
    Instagram,
    WhatsApp,
    Mail,
    Phone,
    // NotificationsIcon,
} from '@mui/icons-material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Link } from 'react-router-dom';
import SalonSearchBar from './SalonSearchBar'; // Your existing search component

// Hide AppBar on scroll
function HideOnScroll(props) {
    const { children } = props;
    const trigger = useScrollTrigger();
    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

export default function Home({ onScrollToLogin, onScrollToLanding }) {
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    // const handleScrollToLogin = () => {
    //     spLoginRef.current?.scrollIntoView({ behavior: "smooth" });
    // };
    // <div ref={spLoginRef}>
    //     <SpLogin />
    // </div>


    const testimonials = [
        {
            name: 'Priya Sharma',
            salon: 'Glow Salon, Mumbai',
            text: 'GroomWell doubled my bookings in just 2 weeks! Clients love the easy online system.',
            rating: 5,
        },
        {
            name: 'Raj Mehta',
            salon: 'StyleMasters, Delhi',
            text: 'Ratings helped me improve services. Now I’m fully booked every weekend!',
            rating: 5,
        },
        {
            name: 'Anita Desai',
            salon: 'Bliss Spa, Bangalore',
            text: 'No more no-shows thanks to reminders. My revenue is up 40%!',
            rating: 5,
        },
    ];

    const nextTestimonial = () => {
        setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    return (
        <>
            {/* Navbar (reuse your existing one or keep this minimal) */}
            {/* <HideOnScroll>
                <AppBar position="sticky" sx={{ bgcolor: 'white', boxShadow: 1 }}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Typography variant="h6" component={Link} to="/" sx={{ color: '#9d55e6', fontWeight: 'bold', textDecoration: 'none' }}>
                            GroomWell
                        </Typography>
                        <Stack direction="row" spacing={2}>
                            <Button component={Link} to="/sp-register" variant="outlined" sx={{ color: '#9d55e6', borderColor: '#9d55e6' }}>
                                For Salons
                            </Button>
                            <Button component={Link} to="/login" variant="contained" sx={{ bgcolor: '#9d55e6' }}>
                                Login
                            </Button>
                        </Stack>
                    </Toolbar>
                </AppBar>
            </HideOnScroll> */}

            {/* HERO SECTION */}
            {/* from Perplexity */}
            <Box sx={{ bgcolor: '#f5f6fa', py: { xs: 1, md: 2 } }}>
                <Container maxWidth="md">
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
                                Grow your Salon Business with GroomWell
                            </Typography>
                            <Typography variant="h5" color="text.secondary" sx={{ mb: 3 }}>
                                Boost appointments, manage your calendar easily, and attract new clients — all in one platform.
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                color="primary"
                                // href="/signup"
                                sx={{ mt: 2 }}
                                onClick={() => {
                                    console.log("Button clicked!"); // ✅ Debug check
                                    if (onScrollToLogin) onScrollToLogin();
                                }}
                            >
                                Register Your Salon Now...
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <img
                                src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80"
                                alt="Salon illustration"
                                style={{ width: '100%', borderRadius: 12, boxShadow: '0 4px 16px rgba(0,0,0,0.12)' }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box
                sx={{
                    bgcolor: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        bgcolor: 'rgba(157, 85, 230, 0.05)',
                        zIndex: 0,
                    },
                }}
            >
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Fade in timeout={800}>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: { xs: '2.5rem', md: '4rem' },
                                        color: '#9d55e6',
                                        mb: 2,
                                        lineHeight: 1.1,
                                    }}
                                >
                                    Book Your Perfect Salon Experience
                                </Typography>
                            </Fade>
                            <Fade in timeout={1200}>
                                <Typography variant="h5" sx={{ color: '#555', mb: 3, fontWeight: 400 }}>
                                    Discover top-rated salons near you. Book, manage, and review — all in one place.
                                </Typography>
                            </Fade>

                            {/* Search Bar */}
                            <Fade in timeout={1600}>
                                <Box sx={{ maxWidth: 500, mb: 3 }}>
                                    <SalonSearchBar />
                                </Box>
                            </Fade>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Button
                                    // component={Link}
                                    // to="/search"
                                    variant="contained"
                                    size="large"
                                    startIcon={<SearchIcon />}
                                    sx={{
                                        bgcolor: '#9d55e6', px: 4, py: 1.5,
                                        '&:hover': {
                                            bgcolor: '#7c3fc0',
                                            color: 'white', // darker purple
                                        },
                                    }}
                                    onClick={() => {
                                        console.log("Button clicked!"); // ✅ Debug check
                                        if (onScrollToLanding) onScrollToLanding();
                                    }}
                                >
                                    Find Salons Now
                                </Button>
                                {/* <Button
                                    component={Link}
                                    to="/sp-register"
                                    variant="outlined"
                                    size="large"
                                    sx={{ borderColor: '#9d55e6', color: '#9d55e6', px: 4, py: 1.5 }}
                                >
                                    List Your Salon
                                </Button> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Zoom in timeout={1000}>
                                <Box
                                    component="img"
                                    src="/assets/depositphotos_29983783-stock-photo-healthy-long-black-hair-beauty.jpg" // Replace with your image
                                    alt="Happy client getting hair styled"
                                    sx={{
                                        width: '100%',
                                        borderRadius: 3,
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                    }}
                                />
                            </Zoom>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* WHY CHOOSE GROOMWELL */}
            <Container sx={{ py: 8 }}>
                <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 6, color: '#9d55e6' }}>
                    Why Salons & Clients Love GroomWell
                </Typography>
                <Grid container spacing={4}>
                    {[
                        { icon: <SearchIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Easy Discovery', desc: 'Clients find you by service, location, and ratings.' },
                        { icon: <CalendarIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Instant Booking', desc: 'Book 24/7. No calls. Real-time availability.' },
                        { icon: <NotificationsActiveIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Automatic Reminders', desc: 'Cut no-shows by 40% with automated SMS/email reminders.' },
                        { icon: <StarIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Ratings & Reputation', desc: 'Collect reviews, attract customers, and grow repeat business.' },
                        { icon: <PeopleIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Grow Loyalty', desc: 'Reminders & feedback keep clients coming back.' },
                        { icon: <TrendingUpIcon sx={{ fontSize: 50, color: '#9d55e6' }} />, title: 'Smart Insights', desc: 'Analytics to optimize services & peak hours.' },
                    ].map((item, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Fade in timeout={600 + i * 200}>
                                <Card sx={{ height: '100%', textAlign: 'center', p: 3, boxShadow: 3, borderRadius: 3 }}>
                                    <Box sx={{ color: '#9d55e6', fontSize: 50, mb: 2 }}>{item.icon}</Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.desc}
                                    </Typography>
                                </Card>
                            </Fade>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* HOW IT WORKS */}
            <Box sx={{ bgcolor: '#f8f9fa', py: 8 }}>
                <Container>
                    <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 6, color: '#9d55e6' }}>
                        How It Works for Clients
                    </Typography>
                    <Grid container spacing={4} alignItems="center">
                        {[
                            { step: '1', title: 'Search & Choose', desc: 'Find salons by service, price, or location.' },
                            { step: '2', title: 'Book Instantly', desc: 'Pick a slot. Get confirmation in seconds.' },
                            { step: '3', title: 'Enjoy & Review', desc: 'Rate your experience. Help others choose.' },
                        ].map((item, i) => (
                            <Grid item xs={12} md={4} key={i}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Chip
                                        label={item.step}
                                        sx={{ bgcolor: '#9d55e6', color: 'white', fontSize: '1.5rem', width: 60, height: 60, borderRadius: '50%', mb: 2 }}
                                    />
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {item.desc}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* TESTIMONIALS */}
            {/* <Container sx={{ py: 8 }}>
                <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 6, color: '#9d55e6' }}>
                    What Salon Owners Say
                </Typography>
                <Box sx={{ maxWidth: 700, mx: 'auto', position: 'relative' }}>
                    <Card sx={{ p: 4, boxShadow: 3, borderRadius: 3, minHeight: 200 }}>
                        <CardContent>
                            <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 3, fontSize: '1.1rem' }}>
                                "{testimonials[testimonialIndex].text}"
                            </Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                {testimonials[testimonialIndex].name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {testimonials[testimonialIndex].salon}
                            </Typography>
                            <Box sx={{ mt: 1 }}>
                                {[...Array(testimonials[testimonialIndex].rating)].map((_, i) => (
                                    <StarIcon key={i} sx={{ color: '#ffc107', fontSize: 20 }} />
                                ))}
                            </Box>
                        </CardContent>
                    </Card>
                    <IconButton
                        onClick={prevTestimonial}
                        sx={{ position: 'absolute', left: -50, top: '50%', transform: 'translateY(-50%)' }}
                    >
                        <ChevronLeft />
                    </IconButton>
                    <IconButton
                        onClick={nextTestimonial}
                        sx={{ position: 'absolute', right: -50, top: '50%', transform: 'translateY(-50%)' }}
                    >
                        <ChevronRight />
                    </IconButton>
                </Box>
            </Container> */}

            {/* CTA SECTION */}

            <Box sx={{ bgcolor: '#1976d2', color: 'white', py: 5 }}>
                <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                        Ready to elevate your Salon?
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        onClick={() => {
                            console.log("Button clicked!"); // ✅ Debug check
                            if (onScrollToLogin) onScrollToLogin();
                        }}
                    // href="/signup"
                    >
                        Sign Up — Start Now!
                    </Button>
                    <Typography sx={{ mt: 3 }}>
                        Questions? Call <a href="tel:+918333842398" style={{ color: 'white', textDecoration: 'underline' }}>
                            +91 83338 42398
                        </a>{' '}
                        or email <a href="mailto:support@groomwell.in" style={{ color: 'white', textDecoration: 'underline' }}>
                            support@groomwell.in
                        </a>
                    </Typography>
                </Container>
            </Box>

            {/* <Box
                sx={{
                    bgcolor: '#9d55e6',
                    color: 'white',
                    py: 8,
                    textAlign: 'center',
                }}
            >
                <Container>
                    <Typography variant="h3" sx={{ fontWeight: 700, mb: 3 }}>
                        Ready to Grow Your Salon?
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}>
                        Join thousands of salon owners filling chairs daily.
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
                        <Button
                            component={Link}
                            to="/sp-register"
                            variant="contained"
                            size="large"
                            sx={{ bgcolor: 'white', color: '#9d55e6', px: 5, py: 1.5, fontWeight: 600 }}
                        >
                            Register Your Salon
                        </Button>
                        <Button
                            component={Link}
                            to="/search"
                            variant="outlined"
                            size="large"
                            sx={{ borderColor: 'white', color: 'white', px: 5, py: 1.5 }}
                        >
                            Book as Client
                        </Button>
                    </Stack>
                </Container>
            </Box> */}

            {/* FOOTER */}
            {/* <Box sx={{ bgcolor: '#333', color: 'white', py: 6 }}>
                <Container>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                GroomWell
                            </Typography>
                            <Typography variant="body2">
                                India’s smartest salon booking platform. Connecting beauty with convenience.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Quick Links
                            </Typography>
                            <Stack spacing={1}>
                                <MuiLink component={Link} to="/about" color="inherit" underline="hover">
                                    About Us
                                </MuiLink>
                                <MuiLink component={Link} to="/contact" color="inherit" underline="hover">
                                    Contact
                                </MuiLink>
                                <MuiLink component={Link} to="/privacy" color="inherit" underline="hover">
                                    Privacy Policy
                                </MuiLink>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                Follow Us
                            </Typography>
                            <Stack direction="row" spacing={2}>
                                <IconButton sx={{ color: 'white' }}>
                                    <Facebook />
                                </IconButton>
                                <IconButton sx={{ color: 'white' }}>
                                    <Instagram />
                                </IconButton>
                                <IconButton sx={{ color: 'white' }}>
                                    <WhatsApp />
                                </IconButton>
                            </Stack>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                <Phone sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} /> +91-XXXXXXXXXX
                                <br />
                                <Mail sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} /> support@groomwell.in
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider sx={{ bgcolor: 'rgba(255,255,255,0.1)', my: 3 }} />
                    <Typography variant="body2" align="center">
                        © 2025 GroomWell. All rights reserved.
                    </Typography>
                </Container>
            </Box> */}
        </>
    );
}